import { render, staticRenderFns } from "./RescueStatus.vue?vue&type=template&id=1706c48f&scoped=true&"
import script from "./RescueStatus.vue?vue&type=script&lang=js&"
export * from "./RescueStatus.vue?vue&type=script&lang=js&"
import style0 from "./RescueStatus.vue?vue&type=style&index=0&id=1706c48f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706c48f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
